module.exports = __webpack_public_path__ + "media/images/isologotipo_c_positivo-21a1637b9e7990893ef767b88c9d274a.svg";